import { StringField } from '@src/permitField/PermitFields';
import * as yup from 'yup';
export class ChangeRequestReasonField extends StringField {
  public static fieldName = 'reason' as const;
  public static validator = yup.string().trim().required('isRequired');
}

export const ChangeRequestSchema = yup.object().shape({
  [ChangeRequestReasonField.fieldName]: ChangeRequestReasonField.validator,
});
